import { render, staticRenderFns } from "./PageTypesList.vue?vue&type=template&id=337b44be&scoped=true"
import script from "./PageTypesList.vue?vue&type=script&lang=js"
export * from "./PageTypesList.vue?vue&type=script&lang=js"
import style0 from "./PageTypesList.vue?vue&type=style&index=0&id=337b44be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337b44be",
  null
  
)

export default component.exports